export default "__VITE_ASSET__DHdnY8WT__"